export default __webpack_public_path__ + "static/retreat_1-f374b8f4847f65d2443edf8f8bf3cd40.jpg";